import { SearchFilterTag } from '@/components';
import { PublishedLabelModifier } from '@/features/project/projects/_models/project-filter';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { isPS } from '@/utils';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const IsPublishedTag: FC = () => {
  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const isPublished = useWatch({
    control,
    name: 'isPublished',
  });

  if (isPS() || !isPublished) {
    return null;
  }

  return (
    <SearchFilterTag
      closable={true}
      label={PublishedLabelModifier[isPublished]}
      onClose={() => {
        setValue('isPublished', null);
      }}
    />
  );
};
